import { useEffect, useState } from "react";
import "./Loader.css";

export default function Loader() {
  const [visible, setVisible] = useState(true);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const leaveTimer = setTimeout(() => setLeaving(true), 900);
    const hideTimer = setTimeout(() => setVisible(false), 1350);
    return () => {
      clearTimeout(leaveTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className={`loader ${leaving ? "loader--leaving" : ""}`} aria-hidden="true">
      <div className="loader__mark">
        <span>FIRM</span>
        <span className="loader__mark-accent">FIT</span>
        <span>FACTORY</span>
      </div>
      <div className="loader__bar">
        <div className="loader__bar-fill" />
      </div>
    </div>
  );
}
